





















import { BEHAVIOR_DAYS } from '@tt4b/ttam-enums';
import { computed, defineComponent, toRefs } from '@vue/composition-api';

const name = 'ttam-behavior-video-day';
export default defineComponent({
  model: {
    prop: 'selectedDay',
    event: 'change',
  },
  props: {
    selectedDay: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const { selectedDay } = toRefs(props);
    const _selectedDay = computed({
      get: () => selectedDay.value,
      set: val => {
        emit('change', val);
      },
    });

    const behaviorDays = computed(() =>
      Object.keys(BEHAVIOR_DAYS)
        .map(key => BEHAVIOR_DAYS[key])
        .filter(item => item.id !== 0),
    );
    return {
      name,
      _selectedDay,
      behaviorDays,
    };
  },
});
